const BASE_API_URL = window["APP_SETTINGS"].REACT_APP_API_URL;
const BASE_API_LOGIN_URL = window["APP_SETTINGS"].REACT_APP_API_LOGIN_URL;
const BASE_OLD_UI_URL = window["APP_SETTINGS"].REACT_APP_OLD_UI_URL;
const BASE_NEW_API_URL = window["APP_SETTINGS"].REACT_APP_ADDIN_API_URL;
export const REDIRECT_MVC = window["APP_SETTINGS"].REACT_APP_LOGIN_MVC;
// TAD-5644 — Vite-native env. Vitest now parses `import.meta.env`, so
// keeping process.env was no longer required for test compatibility.
const BASE_COOKIE_STRING = import.meta.env.VITE_COOKIE_STRING;

export let API_URL = BASE_API_URL;
export let API_LOGIN_URL = BASE_API_LOGIN_URL;
export let OLD_UI_URL = BASE_OLD_UI_URL;
export let NEW_API_URL = BASE_NEW_API_URL;
export let COOKIE_STRING = BASE_COOKIE_STRING;

let setAllUrl = async () => {
  console.log(API_URL);
  console.log(API_LOGIN_URL);
  console.log(OLD_UI_URL);
  console.log(NEW_API_URL);
  console.log(COOKIE_STRING);
  console.log(NEW_API_URL);
};

setAllUrl();
